/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updateHandle.defs.js";
export { main as default } from "./updateHandle.defs.js";
